import { Stack } from '@mantine/core'
import { Button } from '../Common/Button'
import { StatusMessage } from '../Common/StatusMessage'

export const TIME_ENTRY_UNAVAILABLE_MESSAGE = 'Time Entry is temporarily unavailable. Please try again later.'

// What the Time Entry tab shows when it could not find out whether the user is a Replicon user —
// usually Replicon being down. Showing the Vision link instead would send a Replicon user to the
// wrong system, so the tab says it is unavailable and offers a retry. No error detail is shown.
export function TimeEntryUnavailable({ onRetry }: Readonly<{ onRetry: () => void }>) {
  return (
    <Stack gap="xs" align="center">
      <StatusMessage status="error" ta="center">
        {TIME_ENTRY_UNAVAILABLE_MESSAGE}
      </StatusMessage>
      <Button label="Retry" size="xs" variant="outline" onClick={onRetry} />
    </Stack>
  )
}
